import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useConfirmExportFileModal = () => {
  const { t } = useTranslation();
  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('export_file_delete_confirm_title'),
      body: t('export_file_delete_confirm_message'),
      cancelButtonProps: {
        isTertiary: true,
        children: t('cancel'),
        testId: 'export-file-delete-cancel-button',
      },
      okButtonProps: {
        isSecondary: true,
        color: 'danger',
        children: t('export_file_delete_button'),
        testId: 'export-file-delete-confirm-button',
      },
    }),
    [t]
  );
  return useConfirmModal(args);
};
